import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    Kitchen as KitchenIcon,
    Label as LabelIcon,
    Warning as WarningIcon,
    Storage as StorageIcon,
    CheckCircle as CheckCircleIcon,
    ErrorOutline as ErrorOutlineIcon,
    Lightbulb as LightbulbIcon,
    Group as GroupIcon
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3, pb: 6 }}>
            {/* 目次 */}
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアで冷蔵庫を共有する難しさと楽しさ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('rules')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    食品管理ルールの基本と合意形成
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('labeling')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ラベル活用アイデアと実践テクニック
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    実際にあった食品トラブル事例と回避法
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('storage')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    スッキリ片付く冷蔵庫収納術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめとワンポイントアドバイス
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアで冷蔵庫を共有する難しさと楽しさ
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={7}>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            ルームシェア生活の魅力は、日々多様な人と空間を共有しながら新しい発見があること。しかし、意外と「冷蔵庫」がトラブルの火種になりやすいことをご存知でしょうか？<br />
                            食品の管理や共有ルールが曖昧だと、うっかりの食べ間違い、賞味期限切れ、スペースの取り合い……小さなストレスが積み重なりがちです。
                            <br /><br />
                            この記事では、実践的な冷蔵庫管理ノウハウと、食品トラブルを未然に防ぐためのアイデアを余すところなく紹介します。<br />
                            ルームシェア初心者からベテランまで、誰もが心地よく過ごせる「食」の環境作りをサポートします！
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Box sx={{ textAlign: 'center' }}>

                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* 食品管理ルールの基本 */}
            <Box id="rules" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    食品管理ルールの基本と合意形成
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Paper elevation={2} sx={{ p: 3, mb: 2, bgcolor: '#fafafa' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <KitchenIcon color="primary" fontSize="large" />
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                まず大切なのは、<b>「冷蔵庫ルール」を全員で合意する</b>こと。<br />
                                メンバーの生活リズムや価値観が違うからこそ、事前の話し合いがトラブル防止のカギとなります。
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="各自専用スペースを決める（段ごと・バスケットごと等）" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="共有可能な食品と個人専用食品を明確に区別" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="賞味期限切れ食品の扱い方（廃棄ルール）を決める" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <CheckCircleIcon color="success" />
                                    </ListItemIcon>
                                    <ListItemText primary="冷蔵庫掃除の当番や頻度を決めておく" />
                                </ListItem>
                            </List>
                        </Grid>
                    </Grid>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    <LightbulbIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.7 }} />
                    ルールは定期的に見直し、生活環境の変化にも柔軟に対応しましょう。
                </Typography>
            </Box>

            {/* ラベル活用アイデア */}
            <Box id="labeling" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ラベル活用アイデアと実践テクニック
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                        <Box sx={{ textAlign: 'center', mb: { xs: 2, sm: 0 } }}>

                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <Paper elevation={1} sx={{ p: 2, bgcolor: '#f1f8e9', mb: 2 }}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                ラベルを活用すると、<b>「誰のものか」「いつ開封したか」</b>が一目瞭然。<br />
                                シンプルながら、食品トラブルを大きく減らせる工夫です。
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <LabelIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="名前と日付を書くだけの簡単ラベル（マスキングテープや付箋）" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <LabelIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="色分けでオーナーを区別（青＝Aさん、緑＝Bさんなど）" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <LabelIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="共有食品用に「共用」「フリー」などのタグを用意" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <LabelIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="賞味期限が近いものに「早めに使って！」ラベル" />
                                </ListItem>
                            </List>
                        </Paper>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            <LightbulbIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.7 }} />
                            100円ショップの耐水テープやカラーペンを活用すれば、コストも手間も最小限です。
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            {/* トラブル事例 */}
            <Box id="trouble" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    実際にあった食品トラブル事例と回避法
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={7}>
                        <Paper elevation={1} sx={{ bgcolor: '#fff3e0', p: 2, mb: 2 }}>
                            <Typography variant="h6" sx={{ mb: 1 }}>
                                <WarningIcon color="warning" sx={{ verticalAlign: 'middle', mr: 1 }} />
                                よくあるトラブル例
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <ErrorOutlineIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="自分のヨーグルトが勝手に食べられていた"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <ErrorOutlineIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="買ったばかりの食材が見つからない"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <ErrorOutlineIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="賞味期限切れの食品が放置され、臭いやカビが発生"
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <ErrorOutlineIcon color="error" />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="冷蔵庫内がパンパンでお互いの食品がつぶれてしまう"
                                    />
                                </ListItem>
                            </List>
                        </Paper>
                        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                            こうしたトラブルは、ほんの少しの工夫でグッと減らせます。
                        </Typography>
                        <List dense>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="success" />
                                </ListItemIcon>
                                <ListItemText primary="「自分のものを明記」「共有食品は明確に」" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="success" />
                                </ListItemIcon>
                                <ListItemText primary="賞味期限が近い食品はまとめて手前に移動" />
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <CheckCircleIcon color="success" />
                                </ListItemIcon>
                                <ListItemText primary="掃除や整理の当番制を導入" />
                            </ListItem>
                        </List>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <Box sx={{ textAlign: 'center' }}>

                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* 冷蔵庫収納術 */}
            <Box id="storage" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    スッキリ片付く冷蔵庫収納術
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                        <Box sx={{ textAlign: 'center', mb: { xs: 2, sm: 0 } }}>
                            <img
                                src="/images/blog/fridge-organization_roomshare-fridge-management.jpg"
                                alt="透明な収納ボックスやバスケットを使って、冷蔵庫内の棚ごとに食品が分類・整頓されている様子。各ボックスにはネームラベルが貼られ、衛生的で取り出しやすい配置になっている。"
                                style={{ width: '100%', maxWidth: 210, borderRadius: 10, boxShadow: '0 3px 12px rgba(0,0,0,0.08)' }}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={7}>
                        <Paper elevation={0} sx={{ bgcolor: '#e3f2fd', p: 2 }}>
                            <Typography variant="body1" sx={{ mb: 1 }}>
                                「冷蔵庫がごちゃごちゃしやすい…」<br />
                                そんな時は<b>収納アイテム</b>の導入がおすすめ！
                            </Typography>
                            <List dense>
                                <ListItem>
                                    <ListItemIcon>
                                        <StorageIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="100均の透明ケースで「1人1ボックス」を徹底" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <StorageIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="ドアポケットや野菜室は「共用ゾーン」に" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <StorageIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="高さ・奥行きの違う棚は食品の種類ごとに配置" />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <StorageIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText primary="「手前＝早く消費」「奥＝ストック用」で定期チェック" />
                                </ListItem>
                            </List>
                        </Paper>
                        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
                            <LightbulbIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.7 }} />
                            冷蔵庫は「見える化」と「動線の短縮」が快適さのポイントです。
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            {/* まとめとワンポイントアドバイス */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめとワンポイントアドバイス
                </Typography>
                <Divider sx={{ my: 2 }} />
                <Paper elevation={1} sx={{ p: 3, bgcolor: '#f9fbe7' }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        ルームシェアの冷蔵庫管理は、「思いやり」と「ちょっとした工夫」が成功の秘訣。<br />
                        食品トラブルを未然に防ぐには、日頃の声かけや、ルールのアップデートも大切です。
                    </Typography>
                    <List dense>
                        <ListItem>
                            <ListItemIcon>
                                <LightbulbIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="ラベルと収納ボックスで「誰のものか」を明確に！" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <LightbulbIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="ルール決めは、定期的なミーティングで見直し" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <LightbulbIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary="「ありがとう」「使ったよ」の声かけが円満のコツ" />
                        </ListItem>
                    </List>
                </Paper>
                <Box sx={{ textAlign: 'center', mt: 4 }}>
                    <Chip label="冷蔵庫管理" color="primary" variant="outlined" sx={{ mx: 0.5 }} />
                    <Chip label="ルームシェア" color="primary" variant="outlined" sx={{ mx: 0.5 }} />
                    <Chip label="食品トラブル防止" color="primary" variant="outlined" sx={{ mx: 0.5 }} />
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-fridge-management',
    slug: 'roomshare-fridge-management',
    title: 'ルームシェアの「冷蔵庫」管理術と食品トラブル回避法',
    excerpt: 'ルームシェアでの冷蔵庫管理ルールやラベル活用術、実際の食品トラブル事例や収納のコツを、実践的かつ分かりやすく解説します。',
    coverImage: '/images/blog/cover-share-fridge_roomshare-fridge-management.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様なバックグラウンドを持つルームメイトたちが冷蔵庫の前で談笑しながら食品の管理や分け方について話し合っている、和やかで協力的な雰囲気を感じさせるシーン。',
    publishedAt: '2024-06-13T09:30:00.000Z',
    isPublished: true,
    categories: ['ルームシェア', '暮らしの知恵', 'トラブル防止'],
    tags: ['冷蔵庫管理', 'ラベル活用', '収納術', '食品トラブル', 'シェアハウス'],
    author: {
        name: '山田 さやか',
        avatar: '/images/avatars/sayaka-yamada.jpg',
        bio: 'ルームシェア歴7年。快適な共同生活を実現するためのアイデアやノウハウを発信中。生活空間の整理・収納術やコミュニケーション術に詳しい。',
        profilePicture: '/images/avatars/sayaka-yamada.jpg'
    },
    viewCount: 1340,
    contentComponent: PostContent
};

export default post;